import curdGenerator from "./curdGenerator";

export const utility = [
  {
    module: "Utility",
    children: [
      {
        module: "System",
        children: [
          curdGenerator("User"),
          curdGenerator("Company"),
          {
            module: "User Permission",
            permission: "userpermission",
            children: []
          },
          // {
          //   module: "User Lab Permission",
          //   permission: "userlabpermission",
          //   children: []
          // },
          {
            module: "Copy User Permission",
            permission: "copyuserpermission",
            children: []
          },
          {
            module: "Environment Setting",
            permission: "environmentsetting",
            children: []
          },
          {
            module: "Database Backup",
            permission: "databasebackup",
            children: []
          },
          curdGenerator("Bill Check Entry"),
          curdGenerator("Lab Bill Check Entry"),
          curdGenerator("Define Voucher Type"),
          curdGenerator("Open OPD Voucher Type"),
          curdGenerator("Financial Year"),
          {
            module: "Database Split",
            permission: "databasesplit",
            children: []
          }
        ]
      }
    ]
  }
];
